<template>
  <el-table border :data="tableData">
    <!--            show-overflow-tooltip-->
    <template v-for="(col, index) in columns">
      <el-table-column v-if="col.slot" :key="'column' + index" :prop="col.prop" :width="col.width">
        <template slot="header" slot-scope="scope">
          <span>{{ col.label }}</span>
          <el-tooltip effect="light" content placement="top" v-if="col.prop === 'useFileAuditFlag'">
            <div slot="content">开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。</div>
            <i
              class="el-icon-question"
              style="
                font-size: 16px;
                margin-left: 3px;
                color: #a1a1a1;
                cursor: pointer;
              "
            ></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <component @reloadList="reloadList" :is="col.slot" :data="scope.row"></component>
        </template>
      </el-table-column>
      <!-- 已授权成员 -->
      <el-table-column
        v-else-if="col.prop === '_scopeOfUse'"
        :key="'column' + index"
        :label="col.label"
        :width="col.width"
      >
        <template slot-scope="scope">
          <el-popover placement="top" width="200" trigger="hover" @show="moreUse(scope.row)">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>{{ `${col.label}（${userNames.length}人）` }}</span>
              </div>
              <div class="tag-box">
                <el-tag
                  size="small"
                  type="danger"
                  v-for="user of userNames"
                  :key="user.dingTalkUserId"
                  class="text item"
                >{{ user.dingTalkUserName }}</el-tag>
              </div>
            </el-card>
            <span slot="reference" class="point">{{ scope.row._scopeOfUse || "-" }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        :key="'column' + index"
        show-overflow-tooltip
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
      />
    </template>
    <no-data text="暂无数据" slot="empty" />
  </el-table>
</template>

<script>
import { dingtalkApi } from "../../../assets/js/http-serve/dingtalkApi";

export default {
  name: "FlowTable",
  data () {
    return {
      userNames: []
    }
  },
  props: {
    tableData: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  methods: {
    reloadList () {
      this.$emit("reloadList");
    },
    moreUse (row) {
      const dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      dingtalkApi.scopeuserList({
        corpId: dingtokenInfo.dingTalkCorpId,
        dingTalkUserId: dingtokenInfo.dingTalkUserId,
        flowId: row.flowId,
      })
        .then(result => {
          this.userNames = result.data
        })
    },
  }
};
</script>

<style lang="less" scoped>
.box-card {
  width: 40vw;
  padding: 5px;
  .text {
    font-size: 14px;
  }

  .item {
    margin: 0 5px 5px 0;
  }
  .tag-box {
    max-height: 20vh;
    padding: 5px;
    overflow: auto;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
}
.point {
  cursor: pointer;
}
/deep/.el-table__header {
  th {
    background-color: #f4f4f4;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/dingComponents/FlowTable.vue